var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 248 c0 -15 -9 -37 -20 -48 -25 -25 -25 -55 0 -80 11 -11 20 -32 20 -48 l0 -28 90 0 90 0 0 116 0 116 -90 0 -90 0 0 -28z m153 3 c4 0 7 -41 7 -91 0 -50 -3 -91 -7 -91 -23 -4 -110 -5 -120 -1 -21 7 -15 28 12 40 45 21 42 92 -5 107 -22 7 -27 31 -8 37 11 4 96 3 121 -1z m-103 -66 c26 -32 -13 -81 -47 -59 -23 14 -28 41 -13 59 16 19 44 19 60 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.6e766e9193044e6a758541a6704010b7.svg";
export { ForwardRef as ReactComponent };